import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentFormComponent } from "../component-form/component-form.component";
import { ClrIconModule } from "@clr/angular";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";
import { environment as env } from "../../../../environments/environment";
import { Components } from "../../../_shared/interfaces";
import { ComponentsStoreService } from "../../../_shared/services";

@Component({
  selector: 'app-component-update',
  standalone: true,
  imports: [CommonModule, ComponentFormComponent, ClrIconModule, RouterLink],
  templateUrl: './component-update.component.html',
  styleUrls: ['./component-update.component.sass']
})
export class ComponentUpdateComponent implements OnInit {
  componentData?: Components;
  devMode: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private compss: ComponentsStoreService
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
    this.devMode = env.stages.dev;
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.componentData = navigation.extras.state as Components;
    }
  }

  ngOnInit(): void {
    if (!this.componentData) {
      const technical_drawing = this.route.snapshot.params['technical_drawing'];
      if (technical_drawing) {
        this.compss.getComponent(technical_drawing).subscribe({
          next: (response) => {
            if (response?.object && response.object.length > 0) {
              this.componentData = response.object[0];
            } else {
              this.router.navigate(['/component/overview/true']);
            }
          },
          error: () => {
            this.router.navigate(['/component/overview/true']);
          }
        });
      }
    }
  }

  onComponentUpdated(component: Components) {
    // Navigation erfolgt bereits in der Form-Komponente
  }
}
